import React from "react";
import { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import EditScoutMessage from "./EditScoutMessage";
import { useLocation,useNavigate,useSearchParams,useParams } from 'react-router-dom';
import { configData } from "../config";

const ViewScoutMessage = ({ savedData }) => {

    const [isLoading, setIsLoading] = useState(true);
    const [detailedview, setDetailedView] = useState({});
    const {aid} = useParams();
     const app_url = configData.APP_URL;
     
    useEffect(() => {
        Promise.all([
          retrieveEditScoutMessage()
          ]).then(() => {
     
            setIsLoading(false);
           
          })
       
     
    },[]);
    async function  retrieveEditScoutMessage() {
        const response = await fetch(
        app_url+'smwwscout/retrievescoutmessage?id='+aid,
            {
                method: "GET",
        
                headers: {
                'Content-Type': 'application/json',
                },
            }
        )
        const responsedata = await response.json();
        if(responsedata.data.msg == "Success") {
            setDetailedView(
                {
                   body: responsedata.data.result.editbody
                }
            );
           console.log(detailedview);
           

        }
    }
    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (        
                <div>
                    <div className="view-scout-msg-container">
                        <div dangerouslySetInnerHTML={{ __html: detailedview.body }} />
                    </div>
                </div>
            )}
        </>
    );
};
export default ViewScoutMessage;